import type { WithoutInternals } from '../utils';
import { Checkbox, type CheckboxProps } from './src/Checkbox';

const _Checkbox = Checkbox as WithoutInternals<typeof Checkbox>;
export { type CheckboxProps, _Checkbox as Checkbox };
